import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "estimator-wrapper" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "grid" }
const _hoisted_4 = { class: "col-12 lg:col-4" }
const _hoisted_5 = { class: "p-fluid" }
const _hoisted_6 = { class: "col-12 lg:col-4" }
const _hoisted_7 = { class: "p-fluid" }
const _hoisted_8 = { class: "col-12 lg:col-4" }
const _hoisted_9 = { class: "p-fluid" }
const _hoisted_10 = { class: "font-bold" }
const _hoisted_11 = { class: "font-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FieldDropdownNext = _resolveComponent("FieldDropdownNext")!
  const _component_PrimeVueColumn = _resolveComponent("PrimeVueColumn")!
  const _component_PrimeVueDataTable = _resolveComponent("PrimeVueDataTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "card-header" }, [
        _createElementVNode("div", { class: "card-title" }, [
          _createElementVNode("h1", null, "Traffic Estimator"),
          _createElementVNode("div", { class: "subtitle" }, "7-day stats")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_FieldDropdownNext, {
              modelValue: _ctx.filters.traffic_type,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.traffic_type) = $event)),
              options: _ctx.trafficTypes,
              disabled: _ctx.loading
            }, null, 8, ["modelValue", "options", "disabled"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_FieldDropdownNext, {
              modelValue: _ctx.filters.traffic_category,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.traffic_category) = $event)),
              options: _ctx.TRAFFIC_CATEGORIES,
              disabled: _ctx.loading,
              placeholder: "Category",
              "show-clear": ""
            }, null, 8, ["modelValue", "options", "disabled"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_FieldDropdownNext, {
              modelValue: _ctx.filters.device_type,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.device_type) = $event)),
              options: _ctx.DEVICE_TYPES,
              disabled: _ctx.loading,
              placeholder: "Platform",
              "show-clear": ""
            }, null, 8, ["modelValue", "options", "disabled"])
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_PrimeVueDataTable, {
          value: _ctx.data,
          loading: _ctx.loading,
          "show-loader": "",
          sortField: "clicks",
          sortOrder: -1
        }, {
          default: _withCtx(() => [
            _createVNode(_component_PrimeVueColumn, {
              field: "country",
              header: "Country"
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("div", _hoisted_10, _toDisplayString(data.country), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_PrimeVueColumn, {
              field: "clicks",
              header: "Clicks",
              sortable: ""
            }, {
              body: _withCtx(({ data }) => [
                _createTextVNode(_toDisplayString(_ctx.$n(data.clicks)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_PrimeVueColumn, {
              field: "cpc_avg",
              header: "Avg CPC",
              sortable: ""
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$n(data.cpc_avg, 'bid')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_PrimeVueColumn, {
              field: "cpc_max",
              header: "Max CPC",
              sortable: ""
            }, {
              body: _withCtx(({ data }) => [
                _createTextVNode(_toDisplayString(_ctx.$n(data.cpc_max, 'bid')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "loading"])
      ])
    ])
  ]))
}